import { useFormContext } from "react-hook-form";
import { type FormSectionFormFieldsCheckbox } from "~/__generated__/graphql";

export default function Checkbox({
  label,
  mustBeChecked,
}: FormSectionFormFieldsCheckbox) {
  const { register } = useFormContext();

  return (
    <div className="grid grid-cols-[auto_1fr] items-center gap-4 text-white">
      <input
        id={label!}
        {...register(label!)}
        type="checkbox"
        required={mustBeChecked ?? false}
        className="h-6 w-6 rounded-sm border border-white bg-black px-7 py-3 text-lg font-normal leading-relaxed text-white placeholder-white focus-visible:outline-none"
      />
      <label htmlFor={label!}>{mustBeChecked ? `${label}*` : label}</label>
    </div>
  );
}
